import { render, staticRenderFns } from "./channelSort.vue?vue&type=template&id=90bc5196&scoped=true"
import script from "./channelSort.vue?vue&type=script&lang=ts"
export * from "./channelSort.vue?vue&type=script&lang=ts"
import style0 from "./channelSort.vue?vue&type=style&index=0&id=90bc5196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc5196",
  null
  
)

export default component.exports